import {
  FinancialAccountNode,
  OrgNode,
} from '../../../services/orgs/interfaces';
import OrgsService from '../../../services/orgs';
import { StripeEnv } from '../../../util/enums';
import crawlAncestorHierarchy from './crawlAncestorHierarchy';

const DEFAULT_NODE_ENV = StripeEnv.RAISE;

export async function crawlHierarchy(
  rootOrg: OrgNode,
  financialAccountAncestors: FinancialAccountNode[],
  provider: VaultProvider,
  stripeEnv?: StripeEnv,
  payableOrgId?: string,
): Promise<{
  financialAccount: FinancialAccountNode;
  submittedOnYourBehalf: boolean;
} | void> {
  // look for financialAccount at orgId level
  const rootFinancialAccounts = await OrgsService.financialAcctOrg(rootOrg.id);
  const potentialFinancialAccounts = rootFinancialAccounts.filter(
    (rfa) =>
      rfa.processor === provider.toUpperCase() && rfa.status !== 'TERMINATED',
  );
  let rootFinancialAccount: FinancialAccountNode | undefined =
    potentialFinancialAccounts.find(
      (pfa) => pfa.stripeEnv === (stripeEnv || DEFAULT_NODE_ENV),
    );

  // if no match is found with the stripeEnv set it to any fa
  if (rootFinancialAccount === undefined) {
    rootFinancialAccount = potentialFinancialAccounts[0];
  }

  if (rootFinancialAccount !== undefined) {
    return {
      financialAccount: rootFinancialAccount,
      // this financial account belongs to the root org,
      // it has not been submitted by another org on its behalf
      submittedOnYourBehalf: false,
    };
  }

  const ancestorFinancialAccount = await crawlAncestorHierarchy(
    rootOrg,
    financialAccountAncestors,
    provider,
    stripeEnv,
    payableOrgId,
  );

  if (ancestorFinancialAccount !== undefined) {
    return {
      financialAccount: ancestorFinancialAccount,
      // if the org does not directly belong to the provided root org (orgId)
      // it is considered submitted on behalf of the org
      submittedOnYourBehalf: true,
    };
  }
}
